import { defaultState } from 'reducers/upgradePlans';
import persistState from './creators/persistState';

export default persistState({
  key: 'xmPlanUpgradeComplete',
  slicer: state => ({
    upgradePlans: {
      ...defaultState,
      upgradeComplete: state.upgradePlans.upgradeComplete,
    },
  }),
});
